<template #default>
    <form
        v-if="status.detail"
        @submit.prevent="phoneExtUUID ? requestUpdate() : requestCreate()"
    >
        <b-form-group
            :label="$t('label.name')"
            label-cols="4"
            label-align="left"
        >
            <b-form-input
                v-model.trim="createForm.name"
                :class="{ 'is-invalid': submitted && !$v.createForm.name.required }"
                autocomplete="off"
            ></b-form-input>
            <b-form-invalid-feedback v-if="submitted && !$v.createForm.name.required" class="text-right">
                {{ $t("message.requiredX", [$t("label.name")]) }}
            </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
            :label="$t('module.location')"
            label-cols="4"
            label-align="left"
        >
            <multiselect
                v-model="createForm.location"
                track-by="value"
                label="text"
                :placeholder="$t('message.pleaseSelectX', [])"
                :options="locationDdl"
                :searchable="true"
                :allow-empty="true"
                :append-to-body="true"
            />
        </b-form-group>
        <b-form-group
            :label="$t('label.date')"
            label-cols="4"
            label-align="left"
        >
            <DatePicker
                v-model="createForm.date"
                :config="{ format: 'YYYY-MM-DD', useCurrent: false }"
                class="cursor-pointer"
                autocomplete="off"
            />
        </b-form-group>
        <hr class="my-3 mx-n4">
        <div class="d-flex justify-content-end w-100">
            <b-button
                type="button"
                variant="danger"
                class="mr-2 col-2"
                :disabled="!status.save"
                @click="$emit('done')"
            >{{ $t('label.cancel') }}</b-button>
            <b-button
                type="submit"
                variant="info"
                class="col-2"
                :disabled="!status.save"
            >
                <span v-if="status.save">
                    {{ phoneExtUUID ? $t('label.updateX', []) : $t('label.createX', []) }}
                </span>
                <div v-else>
                    <b-spinner small />
                </div>
            </b-button>
        </div>
    </form>
    <div v-else class="d-flex justify-content-center align-items-center m-3">
        <b-spinner class="m-5" variant="info" role="status"></b-spinner>
    </div>
</template>
<script>
import DatePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { phoneExtMethods, lookupMethods } from "@/state/api";
import { PHONE_EXT_MODULE } from "@/state/api/phoneExt.state";

export default {
    props: {
        phoneExtUUID: {
            type: String,
            required: false,
        },
        searchCriteria: {
            type: Object,
            required: false,
        },
    },
    validations() {
        return {
            createForm: {
                name: { required },
            },
        };
    },
    components: { Multiselect, DatePicker },
    async created() {
        await this.lookupLocation({});
        await this.getPhoneExtData();
    },
    data() {
        return {
            submitted: false,
            createForm: this.defaultForm(),
        };
    },
    methods: {
        ...phoneExtMethods,
        ...lookupMethods,
        defaultForm() {
            return {
                uuid: "",
                name: "",
                date: null,
                location: null,
            };
        },
        async getPhoneExtData() {
            if (this.phoneExtUUID) {
                await this.getPhoneExt({ uuid: this.phoneExtUUID })
                    .then((result) => {
                        if (result?.success) {
                            this.createForm = {
                                uuid: this.data.uuid,
                                name: this.data.name,
                                date: this.data.date,
                                location: this.data.location ? {
                                    value: this.data.location.uuid,
                                    text: this.data.location.name,
                                } : null,
                            };
                        }
                    });
            }
        },
        requestCreate() {
            if (!this.status.save) return;
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    ...this.createForm,
                    locationUuid: this.createForm.location?.value || null,
                };
                this.createPhoneExt({data, filter: this.searchCriteria})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success) {
                            this.resetForm();
                            this.$emit("done");
                        }
                    }));
            }
        },
        requestUpdate() {
            if (!this.status.save) return;
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    ...this.createForm,
                    locationUuid: this.createForm.location?.value || null,
                };
                this.updatePhoneExt({data, filter: this.searchCriteria})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success) {
                            this.resetForm();
                            this.$emit("done");
                        }
                    }));
            }
        },
        resetForm() {
            this.createForm = this.defaultForm();
            this.submitted = false;
            this.$v.$reset();
        },
    },
    computed: {
        ...mapState(PHONE_EXT_MODULE, ['status']),
        locationDdl() {
            return this.$store.state.api.lookup.locationDdl || [];
        },
        data() {
            return this.$store.state.api.phoneExt.details;
        },
    },
}
</script>
